import React from "react";
import "./GiftVoucher1.css";
import img8 from "../images/img8.jpg";

const GiftVoucher1 = () => {
  return (
    <div className="gift-voucher1">
      <h2>Looking for the best gift?</h2>
      <div className="giftvoucher1-content">
        <div className="gift-voucher1-content1">
          <p>
            For Christmas, birthday, proposal, bachelor or bachelorette
            celebrations, or just an exciting surprise for someone special? A
            paragliding flight will be an unforgettable moment to share with
            family and friends!
          </p>
          <h3>FOR WHO?</h3>
          <p>
            No inferior age limit only the desire to fly must come from the
            child, not his parents.
          </p>
          <h3>WHEN?</h3>
          <p>This flight only takes place in very calm aerial conditions.</p>

          <h3>KIND OF FLIGHT?</h3>
          <p>
            A calm flight in the peaceful morning air! But if your child is up
            for it, he will have the possibility to fly the glider himself
            and/or discover some acrobatic figures.
          </p>

          <h3>What’s included?</h3>
          <p>
            Fees for takeoff and landing, insurance, and transportation to the
            takeoff site. Plus, complimentary full video and pictures of your
            flight sent directly to your mobile phone in less than 5 minutes, no
            internet required.
          </p>
        </div>
        <img src={img8} alt="" />
      </div>
    </div>
  );
};

export default GiftVoucher1;
